/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteMaintenanceLightingChecksParams,
  GetMaintenanceLightingChecksParams,
  MaintenanceLightingChecks,
  MaintenanceLightingChecksInsertPayload,
  MaintenanceLightingChecksUpdate,
  PatchMaintenanceLightingChecksParams,
  PostMaintenanceLightingChecksParams,
  PostgrestError
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getMaintenanceLightingChecksResponse200 = {
  data: MaintenanceLightingChecks[]
  status: 200
}

export type getMaintenanceLightingChecksResponse206 = {
  data: MaintenanceLightingChecks[]
  status: 206
}

export type getMaintenanceLightingChecksResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getMaintenanceLightingChecksResponseSuccess = (getMaintenanceLightingChecksResponse200 | getMaintenanceLightingChecksResponse206) & {
  headers: Headers;
};
export type getMaintenanceLightingChecksResponseError = (getMaintenanceLightingChecksResponseDefault) & {
  headers: Headers;
};

export type getMaintenanceLightingChecksResponse = (getMaintenanceLightingChecksResponseSuccess | getMaintenanceLightingChecksResponseError)

export const getGetMaintenanceLightingChecksUrl = (params?: GetMaintenanceLightingChecksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_lighting_checks?${stringifiedParams}` : `${backendBaseUrl}/maintenance_lighting_checks`
}

/**
 * @summary Read rows from `maintenance_lighting_checks`.
 */
export const getMaintenanceLightingChecks = async (params?: GetMaintenanceLightingChecksParams, options?: RequestInit): Promise<getMaintenanceLightingChecksResponse> => {

  const res = await fetch(getGetMaintenanceLightingChecksUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getMaintenanceLightingChecksResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getMaintenanceLightingChecksResponse
}


export type postMaintenanceLightingChecksResponse201 = {
  data: MaintenanceLightingChecks[]
  status: 201
}

export type postMaintenanceLightingChecksResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postMaintenanceLightingChecksResponseSuccess = (postMaintenanceLightingChecksResponse201) & {
  headers: Headers;
};
export type postMaintenanceLightingChecksResponseError = (postMaintenanceLightingChecksResponseDefault) & {
  headers: Headers;
};

export type postMaintenanceLightingChecksResponse = (postMaintenanceLightingChecksResponseSuccess | postMaintenanceLightingChecksResponseError)

export const getPostMaintenanceLightingChecksUrl = (params?: PostMaintenanceLightingChecksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_lighting_checks?${stringifiedParams}` : `${backendBaseUrl}/maintenance_lighting_checks`
}

/**
 * @summary Insert one or more rows into `maintenance_lighting_checks`.
 */
export const postMaintenanceLightingChecks = async (maintenanceLightingChecksInsertPayload: MaintenanceLightingChecksInsertPayload,
    params?: PostMaintenanceLightingChecksParams, options?: RequestInit): Promise<postMaintenanceLightingChecksResponse> => {

  const res = await fetch(getPostMaintenanceLightingChecksUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceLightingChecksInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postMaintenanceLightingChecksResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postMaintenanceLightingChecksResponse
}


export type patchMaintenanceLightingChecksResponse200 = {
  data: MaintenanceLightingChecks[]
  status: 200
}

export type patchMaintenanceLightingChecksResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchMaintenanceLightingChecksResponseSuccess = (patchMaintenanceLightingChecksResponse200) & {
  headers: Headers;
};
export type patchMaintenanceLightingChecksResponseError = (patchMaintenanceLightingChecksResponseDefault) & {
  headers: Headers;
};

export type patchMaintenanceLightingChecksResponse = (patchMaintenanceLightingChecksResponseSuccess | patchMaintenanceLightingChecksResponseError)

export const getPatchMaintenanceLightingChecksUrl = (params?: PatchMaintenanceLightingChecksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_lighting_checks?${stringifiedParams}` : `${backendBaseUrl}/maintenance_lighting_checks`
}

/**
 * @summary Update the rows of `maintenance_lighting_checks` matching the given filters.
 */
export const patchMaintenanceLightingChecks = async (maintenanceLightingChecksUpdate: MaintenanceLightingChecksUpdate,
    params?: PatchMaintenanceLightingChecksParams, options?: RequestInit): Promise<patchMaintenanceLightingChecksResponse> => {

  const res = await fetch(getPatchMaintenanceLightingChecksUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(maintenanceLightingChecksUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchMaintenanceLightingChecksResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchMaintenanceLightingChecksResponse
}


export type deleteMaintenanceLightingChecksResponse200 = {
  data: MaintenanceLightingChecks[]
  status: 200
}

export type deleteMaintenanceLightingChecksResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteMaintenanceLightingChecksResponseSuccess = (deleteMaintenanceLightingChecksResponse200) & {
  headers: Headers;
};
export type deleteMaintenanceLightingChecksResponseError = (deleteMaintenanceLightingChecksResponseDefault) & {
  headers: Headers;
};

export type deleteMaintenanceLightingChecksResponse = (deleteMaintenanceLightingChecksResponseSuccess | deleteMaintenanceLightingChecksResponseError)

export const getDeleteMaintenanceLightingChecksUrl = (params?: DeleteMaintenanceLightingChecksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/maintenance_lighting_checks?${stringifiedParams}` : `${backendBaseUrl}/maintenance_lighting_checks`
}

/**
 * @summary Delete the rows of `maintenance_lighting_checks` matching the given filters.
 */
export const deleteMaintenanceLightingChecks = async (params?: DeleteMaintenanceLightingChecksParams, options?: RequestInit): Promise<deleteMaintenanceLightingChecksResponse> => {

  const res = await fetch(getDeleteMaintenanceLightingChecksUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteMaintenanceLightingChecksResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteMaintenanceLightingChecksResponse
}


